var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"disabled":_vm.disabled,"options":_vm.options},model:{value:(_vm.production_batch.recipe_route_id),callback:function ($$v) {_vm.$set(_vm.production_batch, "recipe_route_id", $$v)},expression:"production_batch.recipe_route_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }